<template>
  <button
    class="nosto-facet__value"
    tabindex="-1"
    type="button"
    :data-filter-id="`pf_${facet.field}`"
    :js-nosto-facet="selector"
  >
    <div
      v-if="facet.field === 'skus.customFields.colour'"
      class="nosto-facet__swatch colour-swatches__swatch"
      :class="{ 'colour-swatches__swatch--border': isWhiteSwatch }"
      :style="styles"
    />

    <div
      v-else
      class="nosto-facet__checkbox"
    >
      <icon-tick />
    </div>

    <div
      class="nosto-facet__label text-body-s-desktop"
      v-text="value.value"
    />

    <div
      class="nosto-facet__count text-body-s-desktop"
      v-text="`(${value.count})`"
    />
  </button>
</template>

<script>

/**
 * Vue: Nosto facet value (nosto-facet-value)
 * -----------------------------------------------------------------------------
 * Individual value shown in mobile and desktop facets.
 *
 * @param {Object} facet - Component facet.
 * @param {String} selector - JS attribute selector.
 * @param {Object} value - Facet value.
 *
 */
import { convertHandleToSentenceCase, convertToHandle } from '~/helpers/convert'

import IconTick from '~icons/misc/tick.svg'

export default {
  name: 'NostoFacetValue',

  components: {
    IconTick,
  },

  props: {
    facet: {
      type: Object,
      default: null,
    },
    selector: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: null,
    },
  },

  computed: {

    /**
     * Compute colour handle.
     * @returns {Object}
     */
    colour() {
      if (this.facet.field !== 'skus.customFields.colour') {
        return {}
      }

      const handle = convertToHandle(this.value.value)

      return {
        handle,
        label: convertHandleToSentenceCase(handle),
        url: cnvs.colours[handle] ?? '',
      }
    },

    /**
     * Compute if colour is a white swatch.
     * - Included in white swatch setting.
     * @returns {Boolean}
     */
    isWhiteSwatch() {
      return cnvs.settings.whiteSwatches?.find((handle) => {
        return this.colour.handle === handle.trim()
      })
    },

    /**
     * Compute styles object.
     * @returns {Object}
     */
    styles() {
      const styles = {
        backgroundColor: this.colour.handle,
      }

      if (this.colour.url) {
        styles.backgroundImage = `url(${this.colour.url})`
      }

      return styles
    },
  },
}
</script>
